import { render, staticRenderFns } from "./CustomerTests.vue?vue&type=template&id=9dac94ce&scoped=true&"
import script from "./CustomerTests.vue?vue&type=script&lang=js&"
export * from "./CustomerTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dac94ce",
  null
  
)

export default component.exports